import React from "react";

/**
 * Shimmer-pulse skeleton shown on the artwork result page while data and the
 * CDN image are loading. Same approximate layout as ArtworkDefault so the
 * visual transition is minimal when real content fills in.
 */
const shimmer: React.CSSProperties = {
  backgroundColor: "#e0e0e0",
  backgroundImage:
    "linear-gradient(90deg, #e0e0e0 0%, #f5f5f5 50%, #e0e0e0 100%)",
  backgroundSize: "200% 100%",
  animation: "focus-skeleton-shimmer 1.4s linear infinite",
  borderRadius: "4px",
};

const styles = {
  page: {
    minHeight: "100vh",
    background: "#fff",
    padding: "16px",
    display: "flex",
    flexDirection: "column" as const,
    alignItems: "center",
  },
  header: {
    fontFamily: "inherit",
    fontWeight: "bold" as const,
    color: "#e76f51",
    textTransform: "uppercase" as const,
    marginTop: "12px",
    marginBottom: "16px",
    letterSpacing: "0.05em",
  },
  imageBlock: { ...shimmer, width: "min(85vw, 360px)", aspectRatio: "1 / 1", marginBottom: "20px" },
  artistLine: { ...shimmer, width: "min(55vw, 220px)", height: "18px", marginBottom: "10px" },
  titleLine: { ...shimmer, width: "min(75vw, 300px)", height: "22px", marginBottom: "24px" },
  metaRow: { display: "flex", gap: "8px", width: "min(85vw, 360px)", marginBottom: "10px" },
  metaLabel: { ...shimmer, width: "80px", height: "14px" },
  metaValue: { ...shimmer, flex: 1, height: "14px" },
};

export const ArtworkSkeleton: React.FC = () => (
  <div style={styles.page}>
    <style>{`
      @keyframes focus-skeleton-shimmer {
        0% { background-position: 200% 0; }
        100% { background-position: -200% 0; }
      }
    `}</style>
    <div style={styles.header}>Focused Artwork</div>
    <div style={styles.imageBlock} aria-hidden />
    <div style={styles.artistLine} aria-hidden />
    <div style={styles.titleLine} aria-hidden />
    {[0, 1, 2, 3].map((i) => (
      <div key={i} style={styles.metaRow} aria-hidden>
        <div style={styles.metaLabel} />
        <div style={styles.metaValue} />
      </div>
    ))}
    <span style={{ position: "absolute", left: -9999, top: "auto" }}>
      Loading artwork details
    </span>
  </div>
);
